import styled from 'styled-components';
import { Typography } from '../../../../ui/Typography';

export const PricePerAcreTag = styled(Typography)`
  display: flex;
  margin-top: -15px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
